import {EntityModel} from "@fedeltapointofsale/data-client";
import {StockLevelData} from "./stock-level.data";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class StockLevelEntityModel extends EntityModel<StockLevelData> {
    constructor(injector: Injector) {
        super(injector, StockLevelData);
    }

    override canCreateEntity(): Promise<boolean> {
        return Promise.resolve(false);
    }
}
